import { useState } from "react";
import { MemoryRouter } from "react-router-dom";
import type { ColumnDef } from "@tanstack/react-table";
import { AdminListTable } from "./AdminListTable";

interface Row {
  id: string;
  position?: number;
  name: string;
  resource: string;
}

const rows: Row[] = [
  { id: "1", position: 1, name: "Gate Approval", resource: "Architect" },
  { id: "2", position: 2, name: "Sign-off", resource: "PM" },
  { id: "3", position: 3, name: "Risk Review", resource: "VP Eng" },
];

const columns: ColumnDef<Row>[] = [
  {
    accessorKey: "name",
    header: "Description",
    cell: ({ row }) => row.original.name,
  },
  {
    accessorKey: "resource",
    header: "Resource",
    cell: ({ row }) => row.original.resource,
  },
];

export default {
  title: "CatalogIndex/AdminListTable",
  component: AdminListTable,
  decorators: [
    (Story: any) => (
      <MemoryRouter>
        <Story />
      </MemoryRouter>
    ),
  ],
};

export const ActiveWithEditLinks = () => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  return (
    <AdminListTable<Row>
      columns={columns}
      data={rows}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      draggable
      onReorder={() => {}}
      onEditHref={(row) => `./${row.id}/edit`}
    />
  );
};

export const ArchivedNoEditLinks = () => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  return (
    <AdminListTable<Row>
      columns={columns}
      data={rows}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      draggable={false}
      onEditHref={(row) => `./${row.id}/edit`}
      editLinkDisabled
    />
  );
};

export const Empty = () => (
  <AdminListTable<Row>
    columns={columns}
    data={[]}
    selectedIds={[]}
    setSelectedIds={() => {}}
    emptyMessage="No governance items yet — add one to get started."
  />
);
